// Module
var code = `<!--<header-bar>-->
<!--    <header-bar-title>PMC Details {{\$stateParams.pmcCouponId}}</header-bar-title>-->
<!--</header-bar>-->

<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <div *ngIf="doneLoading" class="HOA-container">
        <div class="HOA-container__header">
            <h1 class="HOA-container__header-text">{{pmc.name}} Details</h1>
        </div>
        <div class="HOA-container__content HOA-container__content--legal">
            <div class="HOA-flextable-component HOA-flextable-component--rowWrapNone">
                <div class="HOA-moobank-flex-left">Mailing Address:&nbsp;</div>
                <div class="HOA-moobank-flex-item">
                    <div>{{pmc.contactInformation.mailingAddress[0].line1}}</div>
                    <div>{{pmc.contactInformation.mailingAddress[0].city}},
                        {{pmc.contactInformation.mailingAddress[0].state}}
                        {{pmc.contactInformation.mailingAddress[0].postalCode}}
                    </div>
                </div>
            </div>

            <div class="HOA-moobank-hrule HOA-flextable-component__cell--100" *ngIf="pmc.contactInformation.phones.length > 0"></div>

            <div class="HOA-flextable-component HOA-flextable-component--rowWrapNone">
                <div class="HOA-moobank-flex-left" *ngIf="pmc.contactInformation.phones.length > 0">Phone:&nbsp;</div>
                <div class="HOA-moobank-flex-item" *ngIf="pmc.contactInformation.phones.length > 0">
                    <a class="u-inline-block" href="tel:{{pmc.contactInformation.phones[0].value}}" aria-label="Phone number">
                        {{pmc.contactInformation.phones[0].value | phone}}
                    </a>
                </div>
            </div>

            <div class="HOA-moobank-hrule HOA-flextable-component__cell--100" *ngIf="pmc.contactInformation.url.length > 0"></div>

            <div class="HOA-flextable-component HOA-flextable-component--rowWrapNone">
                <div class="HOA-moobank-flex-left" *ngIf="pmc.contactInformation.url.length > 0">Website:&nbsp;</div>
                <div class="HOA-moobank-flex-item" *ngIf="pmc.contactInformation.url.length > 0">
                    <a href="http://{{pmc.contactInformation.url[0].value}}">
                        {{pmc.contactInformation.url[0].value}}
                    </a>
                </div>
            </div>

            <div class="HOA-moobank-hrule HOA-flextable-component__cell--100" *ngIf="pmc.contactInformation.email.length > 0"></div>

            <div class="HOA-flextable-component HOA-flextable-component--rowWrapNone">
                <div class="HOA-moobank-flex-left" *ngIf="pmc.contactInformation.email.length > 0">Email:&nbsp;</div>
                <div class="HOA-moobank-flex-item HOA-moobank-emailaddress" *ngIf="pmc.contactInformation.email.length > 0">
                    <a class="u-inline-block" [href]="'mailto:' + pmc.contactInformation.email[0].value">
                        {{pmc.contactInformation.email[0].value}}
                    </a>
                </div>
            </div>

            <div class="HOA-Checking-Detail-button-container">
                <button name="cancel" id="cancel" tid="cancel" type="button" class="Button Button--link" (click)="cancel()">Back</button>
            </div>
        </div>
    </div>
</app-page-content>`;
// Exports
module.exports = code;